<nz-spin [nzSpinning]="loading$ | async">
  <form
    *ngIf="(loading$ | async) === false"
    nz-form
    class="form"
    nzLayout="horizontal"
    [formGroup]="form">
    <div class="drawer-form-wrapper">
      <div class="behaviour-card-sec" *ngIf="!!caseParams.case">
        <div class="header-with-cta mb-24">
          <h3 class="title s-18">
            {{ caseParams.case.student.firstName }}
            {{ caseParams.case.student.lastName }}
          </h3>
        </div>
        <div class="card-content-wrapper">
          <div class="content">
            <h4 class="title">Date Of Birth</h4>
            <p class="desc">
              <svg-icon
                src="/assets/icon/icon-calendar.svg"
                class="icon s-16"
                aria-label="Calendar"></svg-icon>
              {{ caseParams.case.student.dateOfBirth | date: 'MM/dd/yyyy' }}
            </p>
          </div>
          <div class="content">
            <h4 class="title">Supervisor</h4>
            <p class="desc">
              <svg-icon
                src="/assets/icon/icon-supervisor.svg"
                class="icon s-16"
                aria-label="Supervisor"></svg-icon>
              {{ caseParams.case.supervisorName }}
            </p>
          </div>
          <div class="content">
            <h4 class="title">Gender</h4>
            <p class="desc">
              <svg-icon
                src="/assets/icon/icon-male.svg"
                class="icon s-18"
                aria-label="Male"></svg-icon>
              {{ caseParams.case.student.gender }}
            </p>
          </div>
        </div>
      </div>
      <div class="header-with-cta mb-24" *ngIf="isPreviewPage">
        <div class="quetion-badge">
          <h3 class="title s-24">Preview</h3>
        </div>
        <button
          nz-button
          nzType="default"
          [nzLoading]="isPrintLoading"
          (click)="print()">
          <svg-icon
            src="/assets/icon/icon-printer.svg"
            class="icon s-20"
            aria-label="Printer"></svg-icon>
          Download
        </button>
      </div>
      <ng-container *ngIf="isPreviewPage">
        <app-bip-summary
          [behaviorGoal]="behaviorGoal"
          [behaviorDetail]="behaviorDetail"
          [behaviourIntensityList]="behaviourIntensityList"
          [allowManageBehavior]="allowManageBehavior"
          [customQuestionList]="customQuestionList"
          (managePreviewEvent)="redirectToStep($event)"></app-bip-summary>
      </ng-container>
      <ng-container *ngIf="!isPreviewPage">
        <div *ngIf="currentPage === 1 || isPreviewPage">
          <ng-container
            *ngTemplateOutlet="pageHeader; context: { page: 1 }"></ng-container>
          <nz-form-item>
            <nz-form-control>
              <div class="radio-wrapper">
                <nz-radio-group
                  id="behaviorCategory"
                  nzName="behaviorCategory"
                  [nzDisabled]="!form.get('draft')?.value"
                  formControlName="behaviorCategoryId">
                  @for (
                    cat of behaviorCategoryList;
                    track cat;
                    let i = $index
                  ) {
                    <span
                      nz-radio
                      [nzValue]="cat.id"
                      class="box-radio"
                      *ngIf="
                        !isPreviewPage ||
                        (isPreviewPage &&
                          form.get('behaviorCategoryId')?.value === cat.id)
                      ">
                      {{ cat.name }}
                    </span>
                  }
                </nz-radio-group>
              </div>
              <div
                class="ant-form-item-explain-error mt-3"
                *ngIf="form.get('behaviorCategoryId')?.hasError('required')">
                Please select category.
              </div>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div *ngIf="currentPage === 2 || isPreviewPage">
          <ng-container
            *ngTemplateOutlet="pageHeader; context: { page: 2 }"></ng-container>
          <nz-form-item>
            <div class="form-desc">
              Select the specific type of
              {{ getCategoryNameById(form.get('behaviorCategoryId')?.value) }}.
              While you may select multiple behaviors, only do so if you are
              confident they are all &nbsp;
              <button
                nz-button
                type="button"
                nzType="text"
                class="primary-text-btn link-btn"
                (click)="isFunctionalEquivaluentModelVisible = true">
                Functionally Equivalent.</button
              ><span *ngIf="!isPreviewPage" class="error-text">*</span>
            </div>
            <div class="checkbox-wrapper">
              @for (
                subCat of behaviourSubCategoryList;
                track subCat;
                let i = $index
              ) {
                <span
                  [nzDisabled]="form.get('caseBehaviorTypeIds')?.disabled"
                  nz-checkbox
                  *ngIf="
                    !isPreviewPage ||
                    (isPreviewPage &&
                      form
                        .get('caseBehaviorTypeIds')
                        ?.value.includes(subCat.id))
                  "
                  [nzChecked]="
                    form.get('caseBehaviorTypeIds')?.value?.includes(subCat.id)
                  "
                  (nzCheckedChange)="
                    onCheckboxChange('caseBehaviorTypeIds', $event, subCat.id);
                    onBehaviorTypeChange($event, subCat)
                  "
                  [nzValue]="subCat.id">
                  {{ subCat.name }}
                </span>
              }
            </div>
            <div
              class="ant-form-item-explain-error mt-3"
              *ngIf="form.get('caseBehaviorTypeIds')?.hasError('required')">
              Please select at least 1 behavior type.
            </div>
          </nz-form-item>
          <ng-container formArrayName="caseBehaviorTypeDescriptions">
            <nz-divider *ngIf="behaviorTypeDescriptionControls.length > 0" />
            <ng-container
              *ngFor="
                let ctrl of behaviorTypeDescriptionControls;
                let i = index
              "
              [formGroup]="ctrl">
              <nz-form-item>
                <nz-form-label
                  nzFor="behavior-type-description"
                  [nzRequired]="!isPreviewPage">
                  {{
                    getBehaviorTypeDescriptionTitle(ctrl.value.behaviorTypeId)
                  }}
                </nz-form-label>
                <nz-form-control>
                  <textarea
                    id="behavior-type-description"
                    name="description"
                    formControlName="description"
                    rows="4"
                    nz-input
                    placeholder="Enter description"
                    (input)="
                      onControlInputChange($event, ctrl.get('description'))
                    "></textarea>
                  <div class="mt-3 remaining-text">
                    {{ ctrl.value.description.length }} 0f 4000 characters used
                  </div>
                  <div
                    class="ant-form-item-explain-error mt-3"
                    *ngIf="ctrl.get('description')?.errors?.['required']">
                    Please enter your description.
                  </div>
                  <div
                    class="ant-form-item-explain-error mt-3"
                    *ngIf="ctrl.get('description')?.errors?.['maxlength']">
                    Description cannot exceed 4000 characters.
                  </div>
                </nz-form-control>
              </nz-form-item>
            </ng-container>
          </ng-container>
          <div
            *ngIf="
              isPreviewPage && checkValidation(form.get('caseBehaviorTypeIds'))
            ">
            None Selected
          </div>
        </div>
        <div *ngIf="currentPage === 3 || isPreviewPage">
          <ng-container
            *ngTemplateOutlet="pageHeader; context: { page: 3 }"></ng-container>
          <nz-form-item>
            <div class="behavior-badge-wrapper">
              <span
                class="badge"
                *ngFor="let item of getSelectedBehaviorSubCategory()"
                >{{ item?.name }}</span
              >
            </div>
          </nz-form-item>
          <ng-container
            *ngIf="
              behaviorTypeDescription.controls.length > 0 && !isPreviewPage
            ">
            <nz-form-item *ngFor="let ctrl of behaviorTypeDescription.controls">
              <nz-form-label nzFor="aggresion">
                {{ getBehaviorTypeDescriptionTitle(ctrl.value.behaviorTypeId) }}
              </nz-form-label>
              <textarea
                disabled
                id="aggresion"
                name="aggresion"
                rows="4"
                nz-input
                placeholder="Enter details of aggression"
                [value]="ctrl.value.description"
                (input)="
                  onControlInputChange($event, ctrl.get('description'))
                "></textarea>
              <div class="mt-3 remaining-text">
                {{ ctrl.value.description.length }} of 4000 characters used
              </div>
            </nz-form-item>
          </ng-container>
          <nz-form-item>
            <nz-form-label nzFor="definition" [nzRequired]="!isPreviewPage">
              Operational Definition
            </nz-form-label>
            <nz-form-control>
              <textarea
                id="definition"
                name="definition"
                rows="5"
                nz-input
                placeholder="Enter the operational definition"
                formControlName="operationalDefinition"
                (input)="
                  onControlInputChange(
                    $event,
                    form.get('operationalDefinition')
                  )
                ">
              </textarea>
              <div class="mt-3 remaining-text">
                {{ form.value?.operationalDefinition?.length }} of 4000
                characters used
                <div class="btn-wrapper-end">
                  <button
                    nz-button
                    nzType="text"
                    class="primary-text-btn"
                    (click)="openPdfModal()">
                    Operational Definition Sample
                  </button>
                </div>
              </div>
              <div
                class="ant-form-item-explain-error mt-3"
                *ngIf="form.get('operationalDefinition')?.errors?.['required']">
                Please enter your Operational Definition.
              </div>
              <div
                class="ant-form-item-explain-error mt-3"
                *ngIf="
                  form.get('operationalDefinition')?.hasError('maxlength')
                ">
                Operational definition cannot exceed 4000 characters.
              </div>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div *ngIf="currentPage === 4 || isPreviewPage">
          <ng-container
            *ngTemplateOutlet="pageHeader; context: { page: 4 }"></ng-container>
          <nz-form-item>
            <nz-form-label [nzRequired]="!isPreviewPage">
              <p class="form-desc">
                Which of the following best describes the frequency of the
                behavior?
              </p>
            </nz-form-label>
            <div class="radio-wrapper">
              <nz-radio-group
                id="behaviorFrequency"
                nzName="behaviorFrequency"
                formControlName="behaviourFrequencyId">
                @for (
                  freq of behaviourFrequencyList;
                  track freq;
                  let i = $index
                ) {
                  <span
                    nz-radio
                    [nzValue]="freq.id"
                    class="box-radio"
                    *ngIf="
                      !isPreviewPage ||
                      (isPreviewPage &&
                        form.get('behaviourFrequencyId')?.value === freq.id)
                    ">
                    {{ getBehaviorFrequencyLabel(freq.name) }}
                  </span>
                }
              </nz-radio-group>
            </div>
            <div
              *ngIf="
                isPreviewPage &&
                checkValidation(form.get('behaviourFrequencyId'))
              ">
              None Selected
            </div>
            <div
              class="ant-form-item-explain-error mt-3"
              *ngIf="form.get('behaviourFrequencyId')?.hasError('required')">
              Please select Frequency of the behavior.
            </div>
          </nz-form-item>
          <nz-divider />
          <nz-form-item>
            <nz-form-label nzFor="occurrence" [nzRequired]="!isPreviewPage">
              On average how many times does the behavior occur?
            </nz-form-label>
            <nz-form-control>
              <input
                name="occurrence"
                type="text"
                nz-input
                formControlName="behaviourFrequencyCount"
                placeholder="Enter occurrence" />
              <div
                class="ant-form-item-explain-error mt-3"
                *ngIf="
                  form.get('behaviourFrequencyCount')?.hasError('required')
                ">
                Please Enter Behavior Occurrence.
              </div>
              <div
                class="ant-form-item-explain-error mt-3"
                *ngIf="
                  form.get('behaviourFrequencyCount')?.hasError('pattern')
                ">
                Behavior Frequency count only allow numbers.
              </div>
              <div
                class="ant-form-item-explain-error mt-3"
                *ngIf="
                  !form.get('behaviourFrequencyCount')?.hasError('pattern') &&
                  form.get('behaviourFrequencyCount')?.hasError('maxlength')
                ">
                Behavior Frequency count cannot exceed 3 numbers.
              </div>
            </nz-form-control>
          </nz-form-item>
          <nz-divider />
          <nz-form-item>
            <nz-form-label [nzRequired]="!isPreviewPage">
              <p class="form-desc">
                Once the behavior starts, how long does it usually last?
              </p>
            </nz-form-label>
            <div class="radio-wrapper">
              <nz-radio-group
                id="isDurationRequired"
                nzName="isDurationRequired"
                formControlName="isDurationRequired">
                <span nz-radio [nzValue]="false" class="box-radio">
                  Duration does not matter or is instantaneous
                </span>
                <span nz-radio [nzValue]="true" class="box-radio">
                  Minutes
                </span>
              </nz-radio-group>
            </div>
          </nz-form-item>
          <div
            class="form-grid-secondary"
            *ngIf="form.get('isDurationRequired')?.value === true">
            <nz-form-item>
              <nz-form-label
                nzFor="minutes"
                [nzRequired]="
                  form.get('isDurationRequired')?.value === true &&
                  !isPreviewPage
                "
                >Duration
              </nz-form-label>
              <nz-form-control>
                <input
                  name="minutes"
                  type="text"
                  nz-input
                  formControlName="duration"
                  placeholder="Enter duration" />
                <div
                  class="ant-form-item-explain-error mt-3"
                  *ngIf="form.get('duration')?.hasError('required')">
                  Please enter the duration of the behavior.
                </div>
                <div
                  class="ant-form-item-explain-error mt-3"
                  *ngIf="form.get('duration')?.hasError('pattern')">
                  Duration only allow numbers.
                </div>
                <div
                  class="ant-form-item-explain-error mt-3"
                  *ngIf="
                    !form.get('duration')?.hasError('pattern') &&
                    form.get('duration')?.hasError('maxlength')
                  ">
                  Duration cannot exceed 3 numbers.
                </div>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div *ngIf="currentPage === 5 || isPreviewPage">
          <ng-container
            *ngTemplateOutlet="pageHeader; context: { page: 5 }"></ng-container>
          <nz-form-item>
            <nz-form-label [nzRequired]="!isPreviewPage">
              <p class="form-desc">
                How intense is the behavior when it occurs?
              </p>
            </nz-form-label>
            <div class="radio-wrapper">
              <nz-radio-group
                id="languageLevel"
                nzName="radiogroup"
                formControlName="behaviourIntensityId">
                @for (
                  intensity of behaviourIntensityList;
                  track intensity;
                  let i = $index
                ) {
                  <span
                    nz-radio
                    *ngIf="
                      !isPreviewPage ||
                      (isPreviewPage &&
                        form.get('behaviourIntensityId')?.value ===
                          intensity.id)
                    "
                    [nzValue]="intensity.id"
                    class="box-radio"
                    tabindex="0"
                    (click)="showWarningModal()"
                    (keydown)="handleKeyDown($event)">
                    {{ intensity.name }}
                    {{
                      intensity?.description
                        ? '(' + intensity.description + ')'
                        : ''
                    }}
                  </span>
                }
              </nz-radio-group>
              <div
                class="ant-form-item-explain-error mt-3"
                *ngIf="form.get('behaviourIntensityId')?.hasError('required')">
                Please select behavior intensity.
              </div>
            </div>
          </nz-form-item>
          <div
            *ngIf="
              isPreviewPage && checkValidation(form.get('behaviourIntensityId'))
            ">
            None Selected
          </div>
        </div>
        <div *ngIf="currentPage === 6 || isPreviewPage">
          <ng-container
            *ngTemplateOutlet="pageHeader; context: { page: 6 }"></ng-container>
          <nz-form-item>
            <nz-form-label [nzRequired]="!isPreviewPage">
              <p class="form-desc">
                In what settings or locations does this behavior usually occur?
                Select all that apply.
              </p>
            </nz-form-label>
            <div class="checkbox-wrapper">
              @for (
                env of behaviourEnvironmentList;
                track env;
                let i = $index
              ) {
                <span
                  [nzDisabled]="
                    form.get('caseBehaviorEnvironmentIds')?.disabled
                  "
                  nz-checkbox
                  *ngIf="
                    !isPreviewPage ||
                    (isPreviewPage &&
                      form
                        .get('caseBehaviorEnvironmentIds')
                        ?.value.includes(env.id))
                  "
                  [nzChecked]="
                    form
                      .get('caseBehaviorEnvironmentIds')
                      ?.value?.includes(env.id)
                  "
                  (nzCheckedChange)="
                    onCheckboxChange(
                      'caseBehaviorEnvironmentIds',
                      $event,
                      env.id
                    )
                  "
                  [nzValue]="env.id">
                  {{ env.name }}
                </span>
              }
            </div>
            <div
              class="ant-form-item-explain-error mt-3"
              *ngIf="
                form.get('caseBehaviorEnvironmentIds')?.hasError('required')
              ">
              Please select at least 1 behavior environment.
            </div>
          </nz-form-item>
          <div
            *ngIf="
              isPreviewPage &&
              checkValidation(form.get('caseBehaviorEnvironmentIds'))
            ">
            None Selected
          </div>
        </div>
        <div *ngIf="currentPage === 7 || isPreviewPage">
          <ng-container
            *ngTemplateOutlet="pageHeader; context: { page: 7 }"></ng-container>
          <nz-form-item>
            <div class="form-desc">
              Are there &nbsp;
              <button
                nz-button
                type="button"
                nzType="text"
                class="primary-text-btn link-btn"
                (click)="isSettingEventModelVisible = true">
                Setting Events
              </button>
              &nbsp;associated with the behavior? Select all that apply.
              <span *ngIf="!isPreviewPage" class="error-text">*</span>
            </div>
            <div class="checkbox-wrapper">
              <ng-container
                *ngFor="
                  let setting of behaviourSettingEventList
                    | orderBy: 'sequenceNumber'
                ">
                <span
                  [nzDisabled]="
                    form.get('caseBehaviorSettingEventIds')?.disabled
                  "
                  nz-checkbox
                  *ngIf="
                    !isPreviewPage ||
                    (isPreviewPage &&
                      form
                        .get('caseBehaviorSettingEventIds')
                        ?.value.includes(setting.id))
                  "
                  [nzChecked]="
                    form
                      .get('caseBehaviorSettingEventIds')
                      ?.value?.includes(setting.id)
                  "
                  (nzCheckedChange)="
                    onCheckboxChange(
                      'caseBehaviorSettingEventIds',
                      $event,
                      setting.id
                    )
                  "
                  [nzValue]="setting.id">
                  {{ setting.name }}
                </span>
              </ng-container>
            </div>
            <div
              class="ant-form-item-explain-error mt-3"
              *ngIf="
                form.get('caseBehaviorSettingEventIds')?.hasError('required')
              ">
              Please select at least 1 behavior setting event.
            </div>
          </nz-form-item>
          <div
            *ngIf="
              isPreviewPage &&
              checkValidation(form.get('caseBehaviorSettingEventIds'))
            ">
            None Selected
          </div>
        </div>
        <div *ngIf="currentPage === 8 || isPreviewPage">
          <ng-container
            *ngTemplateOutlet="pageHeader; context: { page: 8 }"></ng-container>
          <nz-form-item>
            <nz-form-label [nzRequired]="!isPreviewPage">
              <p class="form-desc">
                What are the common antecedents or triggers for this behavior?
                Select all that apply.
              </p>
            </nz-form-label>
            <div class="checkbox-wrapper">
              @for (
                antecedent of behaviourAntecedentList;
                track antecedent;
                let i = $index
              ) {
                <span
                  [nzDisabled]="form.get('caseBehaviorAntecedentIds')?.disabled"
                  nz-checkbox
                  *ngIf="
                    !isPreviewPage ||
                    (isPreviewPage &&
                      form
                        .get('caseBehaviorAntecedentIds')
                        ?.value.includes(antecedent.id))
                  "
                  [nzChecked]="
                    form
                      .get('caseBehaviorAntecedentIds')
                      ?.value?.includes(antecedent.id)
                  "
                  (nzCheckedChange)="
                    onCheckboxChange(
                      'caseBehaviorAntecedentIds',
                      $event,
                      antecedent.id
                    );
                    onAntecedentChange($event, antecedent)
                  "
                  [nzValue]="antecedent.id">
                  {{ antecedent.name }}
                </span>
              }
            </div>
            <div
              class="ant-form-item-explain-error mt-3"
              *ngIf="
                form.get('caseBehaviorAntecedentIds')?.hasError('required')
              ">
              Please select at least 1 behavior antecedent.
            </div>
          </nz-form-item>
          <ng-container formArrayName="caseBehaviorAntecedentDescription">
            <nz-divider *ngIf="antecedentDescriptionControls.length > 0" />
            <ng-container
              *ngFor="let ctrl of antecedentDescriptionControls; let i = index"
              [formGroup]="ctrl">
              <nz-form-item>
                <nz-form-label
                  nzFor="description"
                  [nzRequired]="!isPreviewPage">
                  {{
                    getBehaviorAntecedentTitle(ctrl.value.behaviorAntecedentId)
                  }}
                </nz-form-label>
                <nz-form-control>
                  <textarea
                    id="description"
                    name="description"
                    formControlName="description"
                    rows="4"
                    nz-input
                    placeholder="Enter description"
                    (input)="
                      onControlInputChange($event, ctrl.get('description'))
                    "></textarea>
                  <div class="mt-3 remaining-text">
                    {{ ctrl.value.description.length }} of 4000 characters used
                  </div>
                  <div
                    class="ant-form-item-explain-error mt-3"
                    *ngIf="ctrl.get('description')?.errors?.['required']">
                    Please enter your description.
                  </div>
                  <div
                    class="ant-form-item-explain-error mt-3"
                    *ngIf="ctrl.get('description')?.errors?.['maxlength']">
                    Description cannot exceed 4000 characters.
                  </div>
                </nz-form-control>
              </nz-form-item>
            </ng-container>
          </ng-container>
          <div
            *ngIf="
              isPreviewPage &&
              checkValidation(form.get('caseBehaviorAntecedentIds'))
            ">
            None Selected
          </div>
        </div>
        <div *ngIf="currentPage === 9 || isPreviewPage">
          <ng-container
            *ngTemplateOutlet="pageHeader; context: { page: 9 }"></ng-container>
          <nz-form-item>
            <nz-form-label [nzRequired]="!isPreviewPage">
              <p class="form-desc">
                After the student engages in the behavior, what kind of
                consequences does it commonly have? Select all that apply.
              </p>
            </nz-form-label>
            <div class="checkbox-wrapper">
              @for (con of behaviorConsequenceList; track con; let i = $index) {
                <span
                  [nzDisabled]="
                    form.get('caseBehaviorConsequenceIds')?.disabled
                  "
                  nz-checkbox
                  *ngIf="
                    !isPreviewPage ||
                    (isPreviewPage &&
                      form
                        .get('caseBehaviorConsequenceIds')
                        ?.value.includes(con.id))
                  "
                  [nzChecked]="
                    form
                      .get('caseBehaviorConsequenceIds')
                      ?.value?.includes(con.id)
                  "
                  (nzCheckedChange)="
                    onCheckboxChange(
                      'caseBehaviorConsequenceIds',
                      $event,
                      con.id
                    );
                    onConsequenceChange($event, con)
                  "
                  [nzValue]="con.id">
                  {{ con.name }}
                </span>
              }
            </div>
            <div
              class="ant-form-item-explain-error mt-3"
              *ngIf="form.get('caseBehaviorTypeIds')?.hasError('required')">
              Please select at least 1 Consequence.
            </div>
          </nz-form-item>
          <ng-container formArrayName="caseBehaviorConsequenceDescription">
            <nz-divider *ngIf="consequenceDescriptionControls.length > 0" />
            <ng-container
              *ngFor="let ctrl of consequenceDescriptionControls; let i = index"
              [formGroup]="ctrl">
              <nz-form-item>
                <nz-form-label
                  nzFor="consequence-description"
                  [nzRequired]="!isPreviewPage">
                  {{
                    getBehaviorConsequenceTitle(
                      ctrl.value.behaviorConsequenceId
                    )
                  }}
                </nz-form-label>
                <nz-form-control>
                  <textarea
                    id="consequence-description"
                    name="description"
                    formControlName="description"
                    rows="4"
                    nz-input
                    placeholder="Enter description"
                    (input)="
                      onControlInputChange($event, ctrl.get('description'))
                    "></textarea>
                  <div class="mt-3 remaining-text">
                    {{ ctrl.value.description.length }} of 4000 characters used
                  </div>
                  <div
                    class="ant-form-item-explain-error mt-3"
                    *ngIf="ctrl.get('description')?.errors?.['required']">
                    Please enter your description.
                  </div>
                  <div
                    class="ant-form-item-explain-error mt-3"
                    *ngIf="ctrl.get('description')?.errors?.['maxlength']">
                    Description cannot exceed 4000 characters.
                  </div>
                </nz-form-control>
              </nz-form-item>
            </ng-container>
          </ng-container>
          <div
            *ngIf="
              isPreviewPage &&
              checkValidation(form.get('caseBehaviorConsequenceIds'))
            ">
            None Selected
          </div>
        </div>
        <div *ngIf="currentPage === 10 || isPreviewPage">
          <ng-container
            *ngTemplateOutlet="
              pageHeader;
              context: { page: 10 }
            "></ng-container>
          <nz-form-item
            *ngIf="this.behaviorGoal && this.behaviorGoal.statusId !== 2">
            <nz-form-label nzFor="district-instructions">
              District Instructions
            </nz-form-label>
            <nz-form-control>
              <textarea
                disabled
                id="district-instructions"
                name="district-instructions"
                rows="4"
                nz-input
                [value]="this.behaviorGoal.templateInstructions"
                placeholder="District Instructions"></textarea>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label nzFor="goal" [nzRequired]="!isPreviewPage">
              Goal
            </nz-form-label>
            <nz-form-control>
              <textarea
                id="goal"
                name="goal"
                rows="4"
                formControlName="goals"
                nz-input
                [placeholder]="
                  getBehvaiorGoalLabel(form.get('behaviorCategoryId')?.value)
                "
                (input)="
                  onControlInputChange($event, form.get('goals'))
                "></textarea>
              <div class="mt-3 remaining-text">
                {{ form.value?.goals?.length }} of 4000 characters used
              </div>
              <div
                class="ant-form-item-explain-error mt-3"
                *ngIf="form.get('goals')?.hasError('required')">
                Please enter goal.
              </div>
              <div
                class="ant-form-item-explain-error mt-3"
                *ngIf="form.get('goals')?.hasError('maxlength')">
                Goal cannot exceed 4000 characters.
              </div>
            </nz-form-control>
          </nz-form-item>
          <button
            nz-button
            nzType="text"
            class="primary-text-btn"
            (click)="openExampleofGoals()">
            Full List of Ex. Behavior Goals
          </button>
        </div>

        <div
          formArrayName="caseBehaviorCustomQuestionAnswer"
          *ngIf="currentPage === 11 || isPreviewPage">
          <ng-container
            *ngTemplateOutlet="
              pageHeader;
              context: { page: 11 }
            "></ng-container>
          <ng-container
            *ngFor="let cq of customQuestionList; let i = index"
            [formGroup]="customQuestionsControls[i]">
            <nz-form-item>
              <nz-form-label
                [nzFor]="'queston' + i"
                [nzRequired]="cq.isRequired && !isPreviewPage">
                <p class="form-desc">
                  {{ cq.customQuestion }}
                </p>
              </nz-form-label>
              <nz-form-control>
                <textarea
                  [id]="'queston' + i"
                  name="answer"
                  formControlName="answer"
                  rows="2"
                  nz-input
                  placeholder="Enter your answer"
                  (input)="
                    onControlInputChange(
                      $event,
                      customQuestionsControls[i].get('answer')
                    )
                  "></textarea>
                <div class="mt-3 remaining-text">
                  {{ customQuestionsControls[i].value.answer?.length || 0 }} of
                  6000 characters used
                </div>
              </nz-form-control>
              <div
                class="ant-form-item-explain-error mt-3"
                *ngIf="
                  customQuestionsControls[i].get('answer')?.errors?.['required']
                ">
                Please enter your answer.
              </div>
              <div
                class="ant-form-item-explain-error mt-3"
                *ngIf="
                  customQuestionsControls[i].get('answer')?.errors?.[
                    'maxlength'
                  ]
                ">
                Answer cannot exceed 6000 characters.
              </div>
            </nz-form-item>
          </ng-container>
          <ng-container *ngIf="customQuestionList.length === 0">
            <p class="form-desc">No Questions Available</p></ng-container
          >
        </div>
      </ng-container>
    </div>
    <div class="display-flex justify-content-between drawer-footer">
      <div class="footer-left">
        <button
          nz-button
          type="button"
          nzType="default"
          (click)="closeDrawer()">
          Cancel
        </button>
        <button
          *ngIf="allowManageBehavior"
          nz-button
          type="button"
          nzType="default"
          [nzLoading]="saveLaterLoading"
          [disabled]="
            isActionInProgress ||
            !form.get('caseId')?.value ||
            !checkCurrentPageValidations()
          "
          (click)="saveForLater()">
          Save for later
        </button>
      </div>
      <div class="footer-right" *ngIf="allowManageBehavior">
        <button
          nz-button
          type="button"
          nzType="default"
          [disabled]="currentPage === 1"
          (click)="onPrevious()">
          Previous
        </button>
        <button
          *ngIf="isPreviewPage"
          nz-button
          type="button"
          nzType="primary"
          [nzLoading]="loading"
          (click)="onSubmit()"
          [disabled]="isActionInProgress || !checkFormGroupValidity()">
          Save & Close
        </button>
        <button
          *ngIf="isPreviewPage && isAssessmentCompleted"
          nz-button
          type="button"
          nzType="primary"
          class="ml-8"
          [nzLoading]="loading"
          (click)="onContinueToAssessment()"
          [disabled]="isActionInProgress || !checkFormGroupValidity()">
          Continue to {{ assessmentLabel | reportLabel | async }}
        </button>
        <button
          *ngIf="form.value.draft && !isPreviewPage"
          nz-button
          type="button"
          nzType="primary"
          [nzLoading]="nextLoading$ | async"
          [disabled]="isActionInProgress || !checkCurrentPageValidations()"
          (click)="onSaveAndNext()">
          Save & Next
        </button>
        <button
          *ngIf="!form.value.draft && !isPreviewPage"
          nz-button
          type="button"
          nzType="primary"
          [nzLoading]="nextLoading$ | async"
          [disabled]="isActionInProgress || !checkCurrentPageValidations()"
          (click)="onSave()">
          Save & Preview
        </button>
      </div>
    </div>
  </form>
</nz-spin>

<ng-template #pageHeader let-page="page">
  <div class="header-with-cta mb-24">
    <div class="quetion-badge">
      <span class="badge"> {{ page }}/{{ totalPages - 1 }} </span>
      <h3 class="title s-18">
        {{ pageTitles[page - 1].title }}
      </h3>
    </div>
  </div>
</ng-template>

<nz-modal
  [nzVisible]="isWarningModalVisible"
  [nzTitle]="modalHeaderTemplate"
  [nzFooter]="modalFooterTemplate"
  (nzOnCancel)="handleCancel()"
  nzWidth="400px"
  nzCentered>
  <ng-template #modalHeaderTemplate>
    <div class="modal-header">
      <div class="modal-icon modal-icon-orange">
        <svg-icon
          src="/assets/icon/icon-info.svg"
          class="icon s-20"
          aria-label="Info"></svg-icon>
      </div>
      <h3 class="ant-modal-title">Warning</h3>
      <p class="text s-14 fw-400 ant-modal-subtitle">
        Whenever challenging behavior poses a threat to the safety of the
        student or to others in the environment, the program should be closely
        monitored by an individual with specific expertise in managing such
        behavior. If you lack such expertise, please involve an appropriate
        person in reviewing the behaviors and possible interventions before
        implementing this plan. Contact your administration if you are unsure
        who to involve in this capacity.
      </p>
      <svg-icon
        src="/assets/icon/icon-modal-circle.svg"
        class="icon s-20 circle-pattern"
        aria-label="Modal Circle"></svg-icon>
    </div>
  </ng-template>

  <ng-template #modalFooterTemplate>
    <div class="modal-footer">
      <button
        nzBlock
        nz-button
        nzType="primary"
        (click)="handleOk()"
        class="justify-content-center">
        I Understand
      </button>
    </div>
  </ng-template>
</nz-modal>

<nz-modal
  [(nzVisible)]="isFunctionalEquivaluentModelVisible"
  [nzTitle]="functionalHeaderTemplate"
  [nzFooter]="functionalFooterTemplate"
  (nzOnCancel)="isFunctionalEquivaluentModelVisible = false"
  nzWidth="400px"
  nzCentered>
  <ng-template #functionalHeaderTemplate>
    <div class="modal-header">
      <div class="modal-icon modal-icon-orange">
        <svg-icon
          src="/assets/icon/icon-info.svg"
          class="icon s-20"
          aria-label="Info"></svg-icon>
      </div>
      <h3 class="ant-modal-title">Functional Equivalent</h3>
      <p class="text s-14 fw-400 ant-modal-subtitle">
        Two or more behaviors that serve the same purpose, or function, for the
        student. Behaviors that look much different from one another can still
        be functionally equivalent. For example, hitting others and screaming
        could be functionally equivalent if a student used both of these
        behaviors as a way to get out of doing work.
      </p>
      <svg-icon
        src="/assets/icon/icon-modal-circle.svg"
        class="icon s-20 circle-pattern"
        aria-label="Modal Circle"></svg-icon>
    </div>
  </ng-template>

  <ng-template #functionalFooterTemplate>
    <div class="modal-footer">
      <button
        nzBlock
        nz-button
        nzType="primary"
        (click)="isFunctionalEquivaluentModelVisible = false"
        class="justify-content-center">
        Close
      </button>
    </div>
  </ng-template>
</nz-modal>

<nz-modal
  [(nzVisible)]="isSettingEventModelVisible"
  [nzTitle]="settingHeaderTemplate"
  [nzFooter]="settingFooterTemplate"
  (nzOnCancel)="isSettingEventModelVisible = false"
  nzWidth="400px"
  nzCentered>
  <ng-template #settingHeaderTemplate>
    <div class="modal-header">
      <div class="modal-icon modal-icon-orange">
        <svg-icon
          src="/assets/icon/icon-info.svg"
          class="icon s-20"
          aria-label="Info"></svg-icon>
      </div>
      <h3 class="ant-modal-title">Setting Events</h3>
      <p class="text s-14 fw-400 ant-modal-subtitle">
        An event or condition under which a student is more likely to engage in
        challenging behavior. A setting event does not directly cause a
        challenging behavior, but rather increases the likelihood that something
        will trigger the challenging behavior. For example, if a student is
        hungry they are more likely to try and get food when they see it. In
        this case, being hungry is the setting event, while seeing food is what
        triggers the behaviors.
      </p>
      <svg-icon
        src="/assets/icon/icon-modal-circle.svg"
        class="icon s-20 circle-pattern"
        aria-label="Modal Circle"></svg-icon>
    </div>
  </ng-template>

  <ng-template #settingFooterTemplate>
    <div class="modal-footer">
      <button
        nzBlock
        nz-button
        nzType="primary"
        (click)="isSettingEventModelVisible = false"
        class="justify-content-center">
        Close
      </button>
    </div>
  </ng-template>
</nz-modal>

<nz-modal
  class="goal-example-modal"
  [(nzVisible)]="isGoalExampleModelVisible"
  [nzTitle]="goalExampleTemplate"
  [nzFooter]="goalExampleFooterTemplate"
  (nzOnCancel)="isGoalExampleModelVisible = false"
  nzWidth="700px"
  nzCentered>
  <ng-template #goalExampleTemplate>
    <div class="modal-header goal-example-modal-header">
      <h3 class="ant-modal-title">Positive and Measurable Behavioral Goals</h3>
      <br />
      <p
        class="text s-14 fw-400 ant-modal-subtitle"
        *ngFor="let behaviorGoal of behaviorGoalExamples.behavioral_goals">
        <span
          ><b
            ><u>{{ behaviorGoal.goal }}</u></b
          >: {{ behaviorGoal.description }}</span
        >
        <br />
        <br />
      </p>
      <p class="text s-14 fw-400 ant-modal-subtitle">
        {{ behaviorGoalExamples.note }}
      </p>
    </div>
  </ng-template>

  <ng-template #goalExampleFooterTemplate>
    <div class="modal-footer">
      <button
        nzBlock
        nz-button
        nzType="primary"
        (click)="isGoalExampleModelVisible = false"
        class="justify-content-center">
        Close
      </button>
    </div>
  </ng-template>
</nz-modal>

<nz-modal
  [(nzVisible)]="isPdfModalVisible"
  [nzTitle]="pdfModalHeaderTemplate"
  [nzFooter]="pdfModalFooterTemplate"
  (nzOnCancel)="isPdfModalVisible = false"
  nzWidth="600px"
  nzCentered>
  <ng-template #pdfModalHeaderTemplate>
    <embed
      src="/assets/samplefiles/MASTERITBOperationalDefinitionsExamples.pdf#toolbar=0"
      type="application/pdf"
      width="100%"
      height="500px" />
  </ng-template>
  <ng-template #pdfModalFooterTemplate> </ng-template>
</nz-modal>
<ng-template #drawerFBATitleTpl>
  <app-drawer-header
    [title]="'Behavior Screener'"
    [subtitle]="'Assessment FBA'"
    [breadcrumbText]="(caseParams.case.student.firstName || '') + '\'' + 's'"
    (drawerClose)="closeAssessmentFbaDrawer()">
  </app-drawer-header>
</ng-template>
